module.exports = __webpack_public_path__ + "static/media/Logo_Barkmere.233331d0.png";